import React, { useEffect, useState } from 'react';
import StyledHeadingText from '../components/Fonts/StyledHeadingText';
import CustomLoading from '../components/customLoading/CustomLoading';
import Table from '../components/tables/Table';
import Breadcrumbs from '../components/BreadCrumbs';
import Pagination from '../components/tables/pagination/Pagination';
import Button from '../components/buttons/Button';
import { toast } from 'react-toastify';
import { formatDate } from '../utils/FormatDateTime';
import { FaWhatsapp } from 'react-icons/fa';
import { BiDevices, BiRefresh } from 'react-icons/bi';
import Dropdown from '../components/inputFields/DropDown';
import SearchBar from '../components/searchBar/SearchBar';
import Card from '../components/cards/Card';
import { getDevices, getDevicesSummary } from '../services/devices';
import { Settings } from 'lucide-react';
import ShowModal from '../utils/ShowModal';
import DeviceDetailsPop from './DeviceDetailsPop';

function Devices() {
    const [loading, setLoading] = useState(false);
    const [cardData, setCardData] = useState([]);
    const [data, setData] = useState({});

    const [filteredType, setFilteredType] = useState("");
    const [searchText, setSearchText] = useState("");
    const [filterDate, setFilterDate] = useState("");
    const [filteredState, setFilteredState] = useState("");
    const [dropDownOptions, setDropDownOptions] = useState([
        {
            label: "All",
            value: "",
        },
        {
            label: "GSM-IOT",
            value: "gsm_iot",
        },
        {
            label: "GSM-WiFi",
            value: "gsm_wifi",
        },
        {
            label: "GSM",
            value: "gsm",
        },
        {
            label: "Soil Test",
            value: "soil_test",
        },
        {
            label: "Weather Station",
            value: "weather_station",
        },
        {
            label: "Data Logger",
            value: "data_logger",
        },
    ]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});


    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Device Id", key: "device_id" },
        { label: "Image", key: "image" },
        { label: "Device Type", key: "device_type" },
        { label: "User", key: "user" },
        { label: "Phone", key: "phone" },
        { label: "Subs. start date", key: "subscription_start_date" },
        { label: "Subs. end date", key: "subscription_end_date" },
        { label: "Is Active", key: "is_active" },
        { label: "Renewals", key: "renewals" },
    ];

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (filters) => {
        setLoading(true);
        try {
            let res = await getDevices(filters || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchStatsData = async () => {
        setLoading(true);
        try {
            let res = await getDevicesSummary();
            if (res.status === 200) {
                const data = res.data;
                setCardData([
                    {
                        "title": "Total Devices",
                        "value": data[0].value,
                        "icon": BiDevices,
                    },
                    {
                        "title": "GSM Motor Controller - V2",
                        "value": data[1].value,
                        "icon": Settings,
                    },
                    {
                        "title": "GSM Motor Controller",
                        "value": data[2].value,
                        "icon": Settings,
                    },
                    {
                        "title": "GSM Motor Controller - IOT",
                        "value": data[3].value,
                        "icon": BiDevices,
                    },
                    {
                        "title": "Rapid Soil Tester",
                        "value": data[4].value,
                        "icon": BiDevices,
                    }
                ]);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
        fetchStatsData();
    }, []);

    const handleTypeChange = (value) => {
        setFilteredType(value);
        fetchData(`?search=${searchText}&date=${filterDate}&state=${filteredState}&device_type=${value}`);
    };

    const handleDateChange = (value) => {
        setFilterDate(value);
        fetchData(`?search=${searchText}&date=${value}&state=${filteredState}&device_type=${filteredType}`);
    }
    const handleStateChange = (value) => {
        setFilteredState(value);
        fetchData(`?search=${searchText}&date=${filterDate}&state=${value}&device_type=${filteredType}`);
    }

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}&date=${filterDate}&state=${filteredState}&device_type=${filteredType}`);
    };

    const resetFilters = () => {
        setFilteredType("");
        fetchData("");
    };

    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Devices' },
        ]} />
        <div className="py-2 flex flex-row gap-2 items-center">
            <StyledHeadingText text={"Devices"} />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-2">
            {cardData.map((card, index) => (
                <Card title={card.title} count={card.value} icon={card.icon} />
            ))}
        </div>
        <div className="py-2 flex flex-row gap-2 items-center">
            <SearchBar
                placeholder="Search for Number/ Name"
                onSearch={handleSearch}
                value={searchText}
            />
            <div className="min-w-48">
                <Dropdown
                    placeholder="Device Type"
                    options={dropDownOptions}
                    onChange={handleTypeChange}
                    value={filteredType}
                    needSearch={false}
                />
            </div>
            {/* <div className="min-w-48">
                <Dropdown
                    placeholder="Select State"
                    options={statesOfIndia.map((e) => ({ label: e, value: e }))}
                    onChange={handleStateChange}
                    value={filteredState}
                    needSearch={false}
                />
            </div> */}

            {/* Date Picker */}
            {/* <DatePicker
                value={filterDate}
                onChange={handleDateChange}
                placeholder="Date"
            /> */}

            {(filteredType.length !== 0 || searchText.length !== 0 || filterDate.length !== 0) && (
                <BiRefresh
                    size={32}
                    className="cursor-pointer text-primary"
                    onClick={resetFilters}
                />
            )}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                i: <p>{index + 1}</p>,
                                user: <span className='flex hover:text-primary cursor-pointer flex-row gap-1 items-center'><p className="max-w-28 truncate" title={item.user} onClick={() => openModal(item)}>{item.user}</p></span>,
                                message: <span className='flex flex-row gap-1 items-center'><p className="max-w-40 truncate cursor-help" title={item.message}>{item.message}</p></span>,
                                image: <img src={item.device_type_image} alt={item.device_type_image} className='w-10 h-10 aspect-square rounded-sm border object-contain' />,
                                to_redirect: <span className='flex flex-row gap-1 items-center'><p className="max-w-32 truncate cursor-help" title={item.to_redirect}>{item.to_redirect}</p></span>,
                                subscription_start_date: <p>{item.subscription_start_date ? formatDate(item.subscription_start_date) : "-"}</p>,
                                subscription_end_date: <p className={(new Date(item.subscription_end_date) < new Date() && item.farm_status !== "pending") ? 'text-red-500 font-bold' : 'text-black'}>{item.subscription_end_date ? formatDate(item.subscription_end_date) : "-"}</p>,
                                phone: <span className='flex flex-row gap-1 items-center hover:text-primary cursor-pointer' onClick={() => openModal(item)}><p className="max-w-28 truncate cursor-help" title={item.phone}>{item.phone}</p></span>,
                                device_type: <span className='flex flex-row gap-1 items-center hover:text-primary cursor-pointer' onClick={() => openModal(item)}><p className="max-w-24 truncate" title={item.device_type}>{item.device_type}</p></span>,
                                device_id: <span className='hover:text-primary flex flex-row gap-1 items-center cursor-pointer' onClick={() => openModal(item)}><p className="max-w-28 truncate cursor-help" title={item.device_id} onClick={() => openModal(item)}>{item.device_id}</p></span>,
                                is_active: <span className='flex flex-row gap-1 items-center hover:text-primary cursor-pointer' onClick={() => openModal(item)}><p className="max-w-4xl truncate cursor-help">{item.is_active}</p></span>,
                                is_iot: <span className='flex flex-row gap-1 items-center hover:text-primary cursor-pointer' onClick={() => openModal(item)}><p className="max-w-4xl truncate cursor-help">{item.is_iot}</p></span>,
                                renewals: <span className='flex flex-row gap-1 items-center hover:text-primary cursor-pointer' onClick={() => openModal(item)}><p className="max-w-4xl truncate cursor-help">{item.renewals}</p></span>,
                                send_payment_link: item.is_iot ? <Button children={<div className='flex flex-row gap-1 items-center text-primary'><FaWhatsapp /> <span>Send Payment Link</span></div>} className="border border-primary rounded-md py-1 px-2" /> : <></>,
                                rowBgColor: (new Date(item.subscription_end_date) < new Date()) && item.farm_status !== "pending" ? 'bg-red-100' : 'bg-white',
                            }))}
                    />
                </div >}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                />
                : <></>
        }
        <ShowModal contentLabel={"User Details alert"} isOpen={modalIsOpen} modalWidth={openingItem.device_type === "Weather Station" ? "90%" : "50%"} isSidebar={true} onRequestClose={closeModal} componentToPass={<DeviceDetailsPop item={openingItem} />} />
    </>);
}

export default Devices;